import { Link } from "react-router-dom";
import { ArrowUpRight } from "lucide-react";

export default function WhyUs() {
  return (
    <section className="section-pad" data-testid="why-us">
      <div className="container-site">
        <div className="grid md:grid-cols-2 gap-10 lg:gap-16 items-center">
          <div className="relative">
            <img
              src="https://images.pexels.com/photos/6466496/pexels-photo-6466496.jpeg?auto=compress&cs=tinysrgb&w=1200"
              alt="Otel Pro Danışmanlık"
              className="rounded-xl w-full object-cover aspect-[4/5] md:aspect-[4/4]"
              loading="lazy"
            />
            <div className="absolute -bottom-6 -right-6 md:-right-10 hidden md:block bg-gold rounded-xl p-6 max-w-[220px] shadow-xl">
              <p className="accent-script text-white text-xl">Uzman Dokunuş</p>
              <p className="text-white/90 text-sm mt-2 leading-relaxed">
                Otelinizin açılışından sonra da sürekli tedarik partneriniz.
              </p>
            </div>
          </div>
          <div>
            <p className="accent-script text-gold text-2xl mb-2">Neden Biz?</p>
            <h2 className="heading-serif text-3xl md:text-4xl font-semibold text-navy mb-5 leading-tight">
              Sadece satmıyoruz —<br />otelinizle birlikte açılıyoruz.
            </h2>
            <p className="text-gray-600 leading-relaxed mb-5">
              15+ yıldır otel sektöründe uzman danışmanlık sunuyoruz. Turizm Bakanlığı yıldız standartlarından,
              buklet seçimine; restoran servis setinden spa ekipmanına kadar her aşamada yanınızdayız.
            </p>
            <ul className="space-y-3 text-sm text-gray-700 mb-7">
              {[
                "Yıldız hedefine göre zorunlu ekipman planlaması",
                "Oda bazlı kişiselleştirilmiş checklist",
                "24 saat içinde özelleştirilmiş teklif",
                "Açılış sonrası sürekli tedarik anlaşmaları",
              ].map((t) => (
                <li key={t} className="flex gap-2">
                  <span className="text-gold">✦</span> {t}
                </li>
              ))}
            </ul>
            <Link to="/hakkimizda" className="btn-outline-gold" data-testid="why-us-more">
              Hakkımızda Daha Fazlası <ArrowUpRight size={16} />
            </Link>
          </div>
        </div>
      </div>
    </section>
  );
}
